import React, { useContext, useEffect, useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Divider, Tooltip, Typography } from '@mui/material';
import { UserSquare } from 'iconsax-react';
import styles from './header.module.scss';
import { Context } from "../../context";
import { useHistory } from "react-router-dom";
import ReferralModal from './referral-modal';
import { observer } from 'mobx-react';

const ProfileActions = observer(({ user }) => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const [showReferralModal, setShowReferralModal] = useState(false);
    const open = Boolean(anchorEl);
    const [name, setName] = useState('');

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const context = useContext(Context);

    const signOut = () => {
        context.actions.signOut();
        history?.push('/login');
    }

    useEffect(() => {
        let n = user?.firstName ? user?.firstName : '';
        if(user?.lastName)
            n += ' ' + user?.lastName
        setName(n);

    }, [user])

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="User Options">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <UserSquare
                            size="32"
                            variant="Bulk"
                            color='#1D1761'
                        />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        borderRadius: "8px",
                        width: '260px',
                        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                        paddingTop: 0
                    },
                }}
            >
                <Box disabled className={styles.profileBtn}>
                    <UserSquare
                        size="40"
                        variant="Bulk"
                        color='#1D1761'
                    />
                    <Box sx={{ ml: 1, mt: 1 }}>
                        <Typography fontWeight='600'>{name}</Typography>
                        {/* <Link color='#888888'>Edit Profile</Link> */}
                    </Box>

                </Box>
                <Divider sx={{ mb: 1 }} />
                <MenuItem component='a' href='/wallet' sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Wallet
                </MenuItem>
                <MenuItem component='a' href='/membership' sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Membership
                </MenuItem>
                <MenuItem onClick={() => setShowReferralModal(true)} sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Refer a friend
                </MenuItem>
                <MenuItem component='a' href='/settings' sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Account Settings
                </MenuItem>
                {/* <MenuItem sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Subscriptions
                </MenuItem> */}
                <MenuItem onClick={signOut} sx={{ margin: '0 auto', borderRadius: '8px' }} className={styles.menuItem}>
                    Sign out
                </MenuItem>
            </Menu>
            <ReferralModal show={showReferralModal} setShow={setShowReferralModal} code={user?.referralCode} />
        </>
    )
});

export default ProfileActions;